module.exports = __webpack_public_path__ + "img/member-binance.374050cf.png";